import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import _ from 'lodash';
import { useRouter } from 'next/router';
import CardV from 'src/components/cards/card-v';
import Carousels from 'src/components/carousels';
import Image from 'src/components/image';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import styled from 'styled-components';
import useVideoIframe from './section-schneider/utils';

import { EMBED_ELECTION_ON_WEB, IFRAME_ELECTION, SHOW_COMMEMORATE } from 'src/constants';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import useResponsive from 'src/utils/devices';
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'));

function SectionNationWeekEnd({ ads, data }) {
  if (_.isEmpty(data)) return null;
  const responsive = useResponsive();
  const router = useRouter();

  const allData = {
    item1: convertDatasets(data?.dataSet, 'background', true),
    item2: convertDatasets(data?.dataSet, 'tag-video-section1', true),
    item3: convertDatasets(data?.dataSet, 'tag-section2', true),
    item4: convertDatasets(data?.dataSet, 'tag-section3', true),
    item5: convertDatasets(data?.dataSet, 'image-section3', true)
  };

  const [resDataSection1, setResDataSection1] = useState();
  const [resDataSection2, setResDataSection2] = useState();
  const [resDataSection3, setResDataSection3] = useState();

  useEffect(() => {
    (async () => {
      try {
        if (!_.isEmpty(allData)) {
          const res = await Promise.all([
            GET(`/api/search/video/tag${convertObjPath({ name: allData.item2 })}&limit=7`, false, true),
            GET(`/api/search/tag${convertObjPath({ name: allData.item3 })}&limit=10`, false, true),
            GET(`/api/search/tag${convertObjPath({ name: allData.item4 })}&limit=6`, false, true)
          ]);
          if (!_.isEmpty(res[0])) setResDataSection1(res[0]);
          if (!_.isEmpty(res[1])) setResDataSection2(_.uniqBy(res[1].data, 'id'));
          if (!_.isEmpty(res[2])) setResDataSection3(_.uniqBy(res[2].data, 'id'));
        }
      } catch (err) {
        console.error(`${timestamp()} ==========> EVENT_ELECTION-2566 ERROR :`, err?.message);
      }
    })();
  }, []);

  return (
    <>
      <SectionWrapper className='section-nation-weekend' bg={allData?.item1} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
        <div className='container'>
          {!_.isEmpty(resDataSection1?.data) && (
            <div className='section-1'>
              <div className='content'>
                <div className='video-list'>
                  <Carousels slideShow={1} autoplay={true} responsiveShow={1} infinite={true} showDots={true}>
                    {_.map(resDataSection1?.data.slice(0, 5), (el, i) => (
                      <div key={i} className={'item-video'}>
                        {useVideoIframe(el)}
                      </div>
                    ))}
                  </Carousels>
                </div>
                <div className='video-item-right'>
                  {_.map(resDataSection1?.data.slice(5, 7), (el, i) => (
                    <div key={i} className={'item-video'}>
                      {useVideoIframe(el)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <IframeElection /> */}
        {!_.isEmpty(IFRAME_ELECTION) && router?.asPath === '/category/politics' && (
          <iframe id='section-iframe-election' className='section-iframe-election' src={EMBED_ELECTION_ON_WEB || IFRAME_ELECTION} width='100%' />
        )}
        <div className='container'>
          {!_.isEmpty(IFRAME_ELECTION) && router?.asPath === '/category/politics' && (
            <>
              <div>
                {responsive.isLaptopMini && (
                  <AdsElectionIframe>
                    <div className='container'>
                      <div className='ads-election-flex'>
                        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_1} data={ads} />}
                        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_2} data={ads} />}
                        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_3} data={ads} />}
                        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_4} data={ads} />}
                      </div>
                    </div>
                  </AdsElectionIframe>
                )}
              </div>
              <div>
                {responsive.isTabletMini && (
                  <div className='ads-election-flex'>
                    <Carousels slideShow={1} autoplay={true} responsiveShow={1} infinite={true} showDots={true}>
                      {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_1} data={ads} />}
                      {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_2} data={ads} />}
                      {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_3} data={ads} />}
                      {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.ELECTION_4} data={ads} />}
                    </Carousels>
                  </div>
                )}
              </div>
            </>
          )}

          {!_.isEmpty(resDataSection2) && (
            <div className='section-2'>
              <div className='header'>
                <h2>{allData?.item3}</h2>
                <a href={`/tags/${allData?.item3}`}>
                  <span>ดูทั้งหมด</span>
                </a>
              </div>
              <div className='content'>
                <div className='card-left'>
                  {_.map(resDataSection2.slice(0, 1), (el, i) => (
                    <div key={i} className={'card-item'}>
                      <CardV
                        data={el}
                        description={false}
                        badge={true}
                        path={el.link}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-energy-time',
                          position: 'ใต้: section-bitkub',
                          data: {
                            title: el?.title,
                            heading: 'ข่าว-section-energy-time',
                            index: 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className='card-list'>
                  {_.map(resDataSection2.slice(0, 5), (el, i) => (
                    <div key={i} className={'card-item'}>
                      <CardV
                        data={el}
                        description={false}
                        showFooter={false}
                        badge={true}
                        path={el.link}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-energy-time',
                          position: 'ใต้: section-bitkub',
                          data: {
                            title: el?.title,
                            heading: 'ข่าว-section-energy-time',
                            index: 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {!_.isEmpty(resDataSection3) && (
            <div className='section-3'>
              <div className='header'>
                <h2>{allData?.item4}</h2>
                <a href={`/tags/${allData?.item4}`}>
                  <span>ดูทั้งหมด</span>
                </a>
              </div>
              <div className='content'>
                <div className='card-list'>
                  {_.map(resDataSection3.slice(0, 4), (el, i) => (
                    <div key={i} className={'card-item'}>
                      <CardV
                        data={el}
                        description={false}
                        showFooter={false}
                        badge={true}
                        path={el.link}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-energy-time',
                          position: 'ใต้: section-bitkub',
                          data: {
                            title: el?.title,
                            heading: 'ข่าว-section-energy-time',
                            index: 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className='image-right'>
                  <Image image={allData.item5} external={true} title={'image'} type={'CARD_MEDIUM'} />
                </div>
              </div>
            </div>
          )}
        </div>
      </SectionWrapper>
    </>
  );
}
const AdsElectionIframe = styled.div`
  .ads-election-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const SectionWrapper = styled.div`
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(${props => props.bg});
  margin-bottom: 20px;
  .iframe-election {
    background-color: unset;
    padding-bottom: 20px;
  }
  .section-iframe-election {
    height: 892px;
    border: unset;
    @media (max-width: 690px) {
      height: 910px;
    }
  }
  .section-1 {
    padding: 60px 0 30px 0;
    @media (max-width: 690px) {
      padding: 40px 0 30px 0;
    }
    .carousel-wrapper {
      display: block;
      margin: 0;
      .slick-dots {
        position: static;
        /* padding-top: 15px; */

        .slick-active {
          button:before {
            color: rgba(200, 200, 200) !important;
          }
        }
        li {
          width: 18px;
          height: 18px;
          button {
            &:before {
              content: '';
              border-radius: 50%;
              background-color: #fff;
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
    .content {
      display: flex;
      gap: 20px;
      .video-list {
        text-align: start;
        width: 67%;
        position: relative;
        @media (max-width: 768px) {
          width: 100%;
        }
      }
      .video-item-right {
        width: 33%;
        @media (max-width: 768px) {
          display: none;
        }
        .item-video {
          &:nth-of-type(1) {
            margin-bottom: 24px;
          }
        }
      }
    }
  }
  .header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    border-bottom: 2px solid #fff;
    margin-bottom: 8px;
    padding-bottom: 6px;
    h2 {
      font-size: 36px;
      color: #fff;
      font-weight: 400;
      @media (max-width: 690px) {
        font-size: 30px;
      }
    }
    span {
      color: #fff;
      font-weight: 300;
    }
  }
  .section-2 {
    padding-bottom: 20px;
    .content {
      display: flex;
      align-items: start;
      gap: 20px;
      .card-left {
        width: 53%;
        @media (max-width: 1024px) {
          width: 59%;
        }
        @media (max-width: 690px) {
          display: none;
        }
        .card-v {
          min-height: 0;
          margin-bottom: 0;
          .card-v-thumb {
            margin-bottom: 0;
            border-radius: 0;
            img {
              border-radius: 0;
            }
          }
          .card-v-content {
            background-color: #fff;
            padding: 10px 10px 0 10px;
            .card-v-content-title {
              font-size: 28px;
              margin: 0;
              @media (max-width: 1024px) {
                font-size: 20px;
              }
            }
            .card-v-content-meta {
              margin-top: 20px;
              justify-content: end;
              padding: 0 10px 4px 0;
              span,
              svg {
                font-size: 14px;
              }
            }
          }
        }
      }
      .card-list {
        width: 50%;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        @media (max-width: 690px) {
          width: 100%;
        }
        .card-item {
          width: calc(50% - 5px);
          &:nth-of-type(1) {
            display: none;
          }
          @media (max-width: 690px) {
            &:nth-of-type(1) {
              display: block;
            }
            &:nth-of-type(5) {
              display: none;
            }
          }
          .card-v-thumb {
            margin-bottom: 0;
            border-radius: 0;
            img {
              border-radius: 0;
            }
          }
          .card-v {
            margin-bottom: 0;
            min-height: 0;
            .card-v-content {
              background-color: #fff;
              padding: 10px;
              .card-v-content-title {
                margin: 0;
                line-height: 1.5;
              }
            }
          }
        }
      }
    }
  }
  .section-3 {
    padding-bottom: 40px;
    .header {
      width: 100%;
      @media (max-width: 690px) {
        width: 100%;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      .card-list {
        width: 100%;
        display: flex;
        gap: 10px;
        @media (max-width: 690px) {
          flex-wrap: wrap;
        }
        .card-item {
          width: 25%;
          @media (max-width: 1024px) {
            width: 33.33%;
            &:nth-of-type(4) {
              display: none;
            }
          }
          @media (max-width: 690px) {
            width: calc(50% - 5px);
            &:nth-of-type(4) {
              display: block;
            }
          }
          .card-v-thumb {
            margin-bottom: 0;
            border-radius: 0;
            img {
              border-radius: 0;
            }
          }
          .card-v {
            margin-bottom: 0;
            min-height: 0;
            .card-v-content {
              background-color: #fff;
              padding: 10px;
              .card-v-content-title {
                margin: 0;
                line-height: 1.5;
              }
            }
          }
        }
      }
      .image-right {
        display: none;
        width: 20%;
        @media (max-width: 690px) {
          display: none;
        }
      }
    }
  }
`;
export default SectionNationWeekEnd;
